import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BrandSwitcherState {
  activeSlug: string | null;
}

const initialState: BrandSwitcherState = {
  activeSlug: null,
};

const brandSwitcherSlice = createSlice({
  name: "brandSwitcher",
  initialState,
  reducers: {
    setActiveBrand: (state, action: PayloadAction<string | null>) => {
      state.activeSlug = action.payload;
    },
  },
});

export const { setActiveBrand } = brandSwitcherSlice.actions;
export default brandSwitcherSlice.reducer;
